export const RESET_PAYMENT_SETUP = 'RESET_PAYMENT_SETUP'
